export { default } from './ProfilePage';
export { default as template } from './profile-page.tpl';
